/* Mega Metals — Product Details tabs section
 * Self-contained tab switching; supports multiple instances and the
 * theme editor's block-select (clicking a tab block reveals its panel).
 */
(function () {
  function activate(root, id) {
    root.querySelectorAll('[data-tab]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-tab') === id);
    });
    root.querySelectorAll('[data-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
    });
  }

  function initDetails(root) {
    var tabs = root.querySelectorAll('[data-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(root, tab.getAttribute('data-tab'));
      });
    });
  }

  document.querySelectorAll('[data-mm-details]').forEach(initDetails);

  /* Theme editor: reveal the tab whose block was selected */
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('[data-panel]');
    var root = e.target.closest('[data-mm-details]');
    if (panel && root) activate(root, panel.getAttribute('data-panel'));
  });
})();
